import { useCallback } from 'react';
import { toast as sonnerToast } from 'sonner';

export function useToast() {
  return useCallback(({ title, description, status = 'info', duration = 3000 }) => {
    const message = title || description || '';
    const desc = title && description ? description : undefined;
    const options = { description: desc, duration };

    if (status === 'error') {
      sonnerToast.error(message, options);
      return;
    }
    if (status === 'success') {
      sonnerToast.success(message, options);
      return;
    }
    if (status === 'warning') {
      sonnerToast.warning(message, options);
      return;
    }
    sonnerToast(message, options);
  }, []);
}
